import { render } from "./Main.vue?vue&type=template&id=572e8d2c"
const script = {}

import exportComponent from "/var/www/kim-moover/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__